"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consentElementsToDateFields = consentElementsToDateFields;
const signer_roles_1 = require("./signer_roles");
/** Editor stores geometry as fractions of the page (0–1). Template `form.json` uses CSS percentages (0–100). */
function fractionToCssPercent(fraction) {
    return Math.round(fraction * 10000) / 100;
}
/**
 * Maps DATE_INPUT elements to `dateFields` for `templates.consent.framework.app~1_0` (SSP-4015).
 *
 * Emitted in the order the fields are printed — by page, then down the page, then across it — because
 * the overlays are absolutely positioned, so keyboard and screen-reader order follows the order the host
 * mounts them in, not their visual position. Same reasoning as {@link consentElementsToChoiceQuestions}.
 *
 * `ec__key` correlates back to `ec__requested_data[].ec__key`, which is what the host submits to Cortex's
 * `set_data` as `ec__identifier` with `type: 'ec__date'`.
 *
 * Unlike a choice overlay, a date overlay is not text-free: it is a native date input, and the browser
 * draws its own locale-ordered format (`mm/dd/yyyy`, `dd/mm/yyyy`, …) inside it. `label` is the author's
 * Label field, carried so the field has an accessible name; it is document text in the document's
 * language, exactly like a choice's `localizedAriaLabel`.
 *
 * Lives here rather than in the editor because the Firebase `consent_bundler` owns compilation while the
 * editor owns authoring — both need the identical wire shape.
 *
 * @param createError builds the thrown error, so `consent_bundler` can surface a 400 `ServiceError`
 *   while other callers get a plain `Error`.
 */
function consentElementsToDateFields(elements, roles = [], createError = (message) => new Error(message)) {
    return elements
        .filter((el) => el.type === 'DATE_INPUT')
        .sort((a, b) => a.page - b.page || a.position.yPct - b.position.yPct || a.position.xPct - b.position.xPct)
        .map((el) => {
        var _a, _b, _c, _d, _e;
        if (typeof el.config.ec__key !== 'string' || el.config.ec__key.length === 0) {
            throw createError(`Consent bundler: date element is missing ec__key (role=${(_a = el.config.ec__signer_role) !== null && _a !== void 0 ? _a : ''}). Every date field must have a stable ec__key so the host can correlate the entered date to ec__requested_data.`);
        }
        return {
            ec__key: el.config.ec__key,
            page: el.page,
            xPct: fractionToCssPercent(el.position.xPct),
            yPct: fractionToCssPercent(el.position.yPct),
            widthPct: fractionToCssPercent(el.position.widthPct),
            heightPct: fractionToCssPercent(el.position.heightPct),
            signerType: (_c = (_b = (0, signer_roles_1.findRoleByLabel)(el.config.ec__signer_role, roles)) === null || _b === void 0 ? void 0 : _b.signerTypeId) !== null && _c !== void 0 ? _c : 'participant',
            role: (0, signer_roles_1.getSignerRoleLabel)(el.config.ec__signer_role),
            optional: (_d = el.config.ec__optional) !== null && _d !== void 0 ? _d : false,
            label: (_e = el.config.ec__label) !== null && _e !== void 0 ? _e : '',
        };
    });
}
//# sourceMappingURL=date_fields.js.map